// extracted by mini-css-extract-plugin
export var container = "styles-module--container--3FGdd";
export var desktop = "1340px";
export var giant = "2200px";
export var itemNumber = "styles-module--itemNumber--T0FGB";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mainContent = "styles-module--mainContent--6KuCB";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var swiped = "styles-module--swiped--xeakx";
export var tablet = "769px";
export var title = "styles-module--title--SBJWb";
export var unswiped = "styles-module--unswiped--MT++D";